import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { CacheService } from '../../../ssr-services/cache/cache.service';

export const initTranslationGuard: CanActivateFn = () => {
  const translateService = inject(TranslateService);

  const cacheService = inject(CacheService);

  const cacheContent = cacheService.cachedContent();

  const platform = inject(PLATFORM_ID);

  if (!cacheContent) {
    return true;
  }

  // CRITICAL FIX: addLangs() MUST be called before use() to prevent translation keys from showing
  const allLanguages = cacheService.allLanguages().map(({ code }) => code.toLowerCase());
  const defaultLang = cacheService.defaultLanguage().code.toLowerCase();

  translateService.addLangs(allLanguages);
  translateService.setFallbackLang(defaultLang);

  return isPlatformServer(platform)
    ? translateService.use(defaultLang).pipe(map(() => true))
    : true;
};
